// Module
var code = "<h2 id=\"direct-debit\">Direct Debit</h2> <p>If you sign up for Direct Debit, your monthly payments are always on time. You may even qualify for an interest rate reduction.</p> ";
// Exports
export default code;